export default __webpack_public_path__ + "static/feature13banner-d543338dd455a9290283058c34495942.svg";